import React, { useContext } from 'react';
import { AddCouponFormContext } from '../../../Context/Coupons/AddCouponFormContext';
import { sanitizeToPositiveInteger } from '../../../lib/utils/utils';

function SetBuyXgetX() {
    const { formInputs, setFormInputs, formErrors } = useContext(AddCouponFormContext);

    const handleChange = (e) => {
        const {name, value} = e.target;
        const cleanedValue = sanitizeToPositiveInteger(value);
        setFormInputs({ ...formInputs, [name]: cleanedValue });
    };

    return (
        <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Set Offer Value</h1>

                <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.buyXgetX}</p>
            </div>

            <div className="flex items-center gap-4">
                <div className="flex flex-col gap-2">
                    <label className='font-normal text-[16px] leading-8 text-[#121212] cursor-pointer' htmlFor="buy-amount">Buy</label>

                    <input 
                        className='w-[200px] h-14 border border-[#EAEAEA] bg-[#F5F5F5] px-2 py-[6px] rounded-lg outline-none font-medium text-[14px] leading-5 text-[#121212] placeholder:text-[#666666] focus:border-primaryColor'
                        type="text" 
                        placeholder='0' 
                        id='buy-amount' 
                        name='buyAmount' 
                        value={formInputs.buyAmount} 
                        onChange={handleChange} 
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <label className='font-normal text-[16px] leading-8 text-[#121212] cursor-pointer' htmlFor="get-amount">Get</label>

                    <input 
                        className='w-[200px] h-14 border border-[#EAEAEA] bg-[#F5F5F5] px-2 py-[6px] rounded-lg outline-none font-medium text-[14px] leading-5 text-[#121212] placeholder:text-[#666666] focus:border-primaryColor'
                        type="text" 
                        placeholder='0' 
                        id='get-amount' 
                        name='getAmount' 
                        value={formInputs.getAmount} 
                        onChange={handleChange} 
                    />
                </div>
            </div>
        </div>
    );
}

export default SetBuyXgetX;
